// extracted by mini-css-extract-plugin
export default {"dropdown":"UserAccountMenu_dropdown__UQhqm","arrow":"UserAccountMenu_arrow__xRQSk","dropdownItem":"UserAccountMenu_dropdownItem__LljPG"};